// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { default } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/node_modules/.pnpm/dumi@2.4.21_@babel+core@7.23.6_@rspack+core@1.4.11_@swc+helpers@0.5.17__@swc+helpers@0._7953daf4ecce4e4907c4653237bc2c63/node_modules/dumi/theme-default/slots/ContentTabs/index.js';
